import { cva, type VariantProps } from 'class-variance-authority';

const bottomSheetOverlayVariants = cva('fixed inset-0 z-50 bg-black/40 flex items-end justify-center animate-fade-in');

const bottomSheetContentVariants = cva(
  [
    'relative w-full bg-surface border border-border rounded-t-[20px]',
    'shadow-card max-h-[92vh] overflow-y-auto',
    'px-[30px] pt-2 pb-6',
    'touch-pan-y',
  ].join(' '),
  {
    variants: {
      size: {
        full: '',
        sm: '',
        md: '',
      },
    },
    defaultVariants: {
      size: 'full',
    },
  },
);

export type BottomSheetContentProps = VariantProps<typeof bottomSheetContentVariants>;

export { bottomSheetOverlayVariants, bottomSheetContentVariants };
